import api from './api';

/**
 * Servicio para gestionar facturas
 */
export const facturasService = {
  /**
   * Obtener una factura por ID
   * @param {number} id - ID de la factura
   */
  getById: async (id) => {
    const response = await api.get(`/facturas/${id}`);
    return response;
  },

  /**
   * Obtener una factura por ID de venta
   * @param {number} ventaId - ID de la venta
   */
  getByVenta: async (ventaId) => {
    const response = await api.get(`/facturas/venta/${ventaId}`);
    return response;
  },

  /**
   * Generar una nueva factura desde una venta (método legacy - timbra directamente)
   * @param {object} factura - Datos de la factura (VentaID, Serie opcional)
   */
  generar: async (factura) => {
    const response = await api.post('/facturas/generar', factura);
    return response;
  },

  /**
   * Crear una prefactura (borrador) editable desde una venta
   * @param {object} prefactura - Datos de la prefactura (VentaID, Serie, UsoCFDI, FormaPago, etc.)
   */
  crearPrefactura: async (prefactura) => {
    const response = await api.post('/facturas/crear-prefactura', prefactura);
    return response;
  },

  /**
   * Actualizar una prefactura (borrador) antes del timbrado
   * @param {number} id - ID de la factura
   * @param {object} prefactura - Datos para actualizar (UsoCFDI, FormaPago, etc.)
   */
  actualizarPrefactura: async (id, prefactura) => {
    const response = await api.put(`/facturas/${id}/actualizar-prefactura`, prefactura);
    return response;
  },

  /**
   * Timbrar una prefactura existente
   * @param {number} id - ID de la factura
   */
  timbrarPrefactura: async (id) => {
    const response = await api.post(`/facturas/${id}/timbrar-prefactura`);
    return response;
  },

  /**
   * Reintentar el timbrado de una factura
   * @param {number} id - ID de la factura
   */
  reintentarTimbrado: async (id) => {
    const response = await api.post(`/facturas/${id}/reintentar-timbrado`);
    return response;
  },

  /**
   * Cancelar una factura
   * @param {number} id - ID de la factura
   * @param {object} cancelacion - Datos de la cancelación (Motivo)
   */
  cancelar: async (id, cancelacion) => {
    const response = await api.post(`/facturas/${id}/cancelar`, cancelacion);
    return response;
  },

  /**
   * Descargar el XML de una factura
   * @param {number} id - ID de la factura
   */
  descargarXML: async (id) => {
    const response = await api.get(`/facturas/${id}/xml`, {
      responseType: 'blob',
    });
    return response;
  },

  /**
   * Descargar el PDF de una factura
   * @param {number} id - ID de la factura
   */
  descargarPDF: async (id) => {
    const response = await api.get(`/facturas/${id}/pdf`, {
      responseType: 'blob',
    });
    return response;
  },

  /**
   * Descargar el XML del acuse de cancelación de una factura
   * @param {number} id - ID de la factura
   */
  descargarAcuseCancelacionXML: async (id) => {
    const response = await api.get(`/facturas/${id}/cancelacion/xml`, {
      responseType: 'blob',
    });
    return response;
  },
};

